import createState from './state';

export const RESET_STATE = (state) => {
  Object.assign(state, createState());
};

export const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

export const SET_ITINERARIES = (state, { items, pagination }) => {
  state.items = items;
  state.pagination = pagination;
};

export const SET_COUNTS = (state, { search, todos, ativos, inativos }) => {
  state.counts = { todos, ativos, inativos };
  state.countsSearch = search;
};

export const SET_FILTERS = (state, filters) => {
  state.filters = { ...state.filters, ...filters };
};

export const SET_ERROR = (state, error) => {
  state.error = error;
};
